const BookingSearch = {
  ALL: 'all',
  UPCOMING: 'upcoming',
  PAST: 'past',
  CANCELLED: 'cancelled',
  SHARED: 'shared',
}

export { BookingSearch }
